<template>
    <rkm-overlay>
        <rkm-layout-body title="Atendimento odontológico">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/atencao-basica/atendimento-odontologico/List'

export default {
    components: { List },
}
</script>